import {useEffect} from "react";
import {useSelector} from "react-redux";
import {GAME_STATE} from "utils";
import View from "./View";

export default function Container() {
  const {gameState} = useSelector(state => state.game);

  useEffect(() => {
    if (gameState === GAME_STATE.ENDED) {
      const joystick = document.querySelector("#joystick");
      const jumpButton = document.querySelector("#joystick_button_J");

      if (joystick) {
        joystick.remove();
      }

      if (jumpButton) {
        jumpButton.remove();
      }
    }
  }, [gameState]);

  return <View gameState={gameState} />;
}
